import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"
import Select from "../../../../../helpers/ui/CustomSelect"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
} from "reactstrap"

import TableActiveComponent from "./Components/TableActiveComponent"
import DataTableBloc from "./Blocs/DataTableBloc"

const reformatAtasan = (datas) => {
    return (datas || []).map((data) => {
        return {
            label: data.position_name !== "Semua Data"
                ? data.employee_name + " (" + data.position_name + ")"
                : data.position_name,
            value: data.position_uuid,
            model: data,
        }
    })
}

const statusCuti = [
    { value: -1, label: 'Menunggu Proses Persetujuan Atasan' },
    // { value: 0, label: 'Menunggu Proses Persetujuan Admin' },
    { value: 1, label: 'Disetujui' },
    { value: 2, label: 'Ditolak' },
    { value: 3, label: 'Dalam Proses Pembatalan' },
    { value: 4, label: 'Cuti Dibatalkan' },
]

const ListAtasanView = (props) => {

    // Retrieve Data Pegawai by Admin / Pegawai
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "")
    : (employeeSeleted != null ? employeeSeleted : "")

    const activeRef = useRef();
    const dataTableBloc = useRef(new DataTableBloc()).current;
    const roleId = localStorage.getItem("currentRoleId") || '1'

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()
    const [filter, setFilter] = useState()
    const [additionalFilter, setAdditionalFilter] = useState()
    const [status, setStatus] = useState(null)
    const [atasanOptions, setAtasanOptions] = useState([])
    const [atasanSelected, setAtasanSelected] = useState(
        roleId === '1'
            ? null
            : {
                position_uuid: peg_detail.employee_current_position_uuid,
                position_name: peg_detail.employee_current_position_name,
                employee_uuid: peg_detail.employee_uuid,
                employee_name: peg_detail.employee_full_name,
                tipe: 1,
            }
    )
    const [loadingAtasan, setLoadingAtasan] = useState(true)
    const [atasanWorkUnitUuid, setAtasanWorkUnitUuid] = useState(null)
    const [loadingPositionDetail, setLoadingPositionDetail] = useState(false)

    // Jabatan utama diambil dari data profil sendiri (peg_detail), bukan dari listAtasan,
    // karena view eselon (transaction.atasan_tunsus) belum tentu punya row jabatan definitif
    // kalau jabatan utamanya bukan jabatan eselon (misal staf yang lagi Plt eselon).
    const jabatanUtamaOption = {
        label: peg_detail.employee_current_position_name,
        value: peg_detail.employee_current_position_uuid,
        model: {
            position_uuid: peg_detail.employee_current_position_uuid,
            position_name: peg_detail.employee_current_position_name,
            employee_uuid: peg_detail.employee_uuid,
            employee_name: peg_detail.employee_full_name,
            tipe: 1,
        },
    }
    // hasil listAtasan cuma dipakai buat ambil jabatan Plt/Plh (tipe=2); jabatan utama
    // (definitif) selalu pakai jabatanUtamaOption di atas, bukan dari sini.
    const pltOptions = atasanOptions.filter((opt) => opt.model && opt.model.tipe === 2)
    // Administrator tetap browsing full daftar org (termasuk row "Semua Data"),
    // selain itu (Eselon/staf) opsi-nya {jabatan utama, ...jabatan Plt/Plh}
    const jabatanOptions = roleId === '1' ? atasanOptions : [jabatanUtamaOption, ...pltOptions]
    // Ada tugas tambahan (Plt/Plh) kalau ada entry tipe=2 di daftar jabatan pemohon
    const hasPlt = roleId === '1' || pltOptions.length > 0
    const selectedJabatanOption = jabatanOptions.find(
        (opt) => opt.model && atasanSelected && opt.model.position_uuid === atasanSelected.position_uuid
    ) || null
    // Filter khusus (override work_unit_uuid + strict_scope) cuma aktif kalau user beneran
    // lagi milih jabatan Plt/Plh (tipe=2), atau Administrator milih posisi tertentu (bukan
    // row "Semua Data"). Default jabatan utama (tipe=1) di roleId Eselon/staf tetap pakai
    // perilaku lama (work_unit_uuid & employee_uuid bawaan peg_detail, tanpa strict_scope).
    const isJabatanFilterActive = atasanSelected
        && atasanSelected.position_uuid
        && atasanSelected.position_uuid !== "Semua Data"
        && (roleId === '1' || atasanSelected.tipe === 2)

    useEffect(() => {
        const subscription = dataTableBloc.listAtasanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    setLoadingAtasan(true)
                    break
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        const options = reformatAtasan(result.data.response.result)
                        setAtasanOptions(options)
                        if (roleId === '1') {
                            // Administrator: default entry pertama (row filter "Semua Data")
                            setAtasanSelected(options[0]?.model || null)
                        }
                        // Eselon/staf: default jabatan utama udah di-set dari awal (initial
                        // state), gak perlu di-override di sini walau ternyata ada Plt/Plh
                    }
                    setLoadingAtasan(false)
                    break
                case apiResponse.ERROR:
                    setLoadingAtasan(false)
                    break
                default:
                    break
            }
        })

        const now = new Date()
        const echelonLocal = JSON.parse(localStorage.getItem("currentEchelonCode") || "null")
        const echelonCode = echelonLocal || userdata?.echelon_code
        const isEchelon = typeof echelonCode === "string" && (echelonCode.startsWith("1") || echelonCode.startsWith("2")) ? 1 : 0

        dataTableBloc.fetchAtasan({
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            roleId: roleId,
            is_echelon: isEchelon,
        })

        return () => subscription.unsubscribe()
    }, [])

    // Row atasan bisa jabatan Plt/Plh yang employee_uuid-nya sama dengan diri sendiri
    // tapi work unit-nya beda (position_uuid != jabatan definitif). Resolve position_uuid
    // -> position_work_unit_uuid lewat Master/Position/detail supaya scope hirarki ikut
    // jabatan yang dipilih, bukan cuma employee_uuid yang gak berubah.
    useEffect(() => {
        const subscription = dataTableBloc.positionDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    setLoadingPositionDetail(true)
                    break
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        setAtasanWorkUnitUuid(result.data.response?.position_work_unit_uuid || null)
                    }
                    setLoadingPositionDetail(false)
                    break
                case apiResponse.ERROR:
                    setAtasanWorkUnitUuid(null)
                    setLoadingPositionDetail(false)
                    break
                default:
                    break
            }
        })

        if (isJabatanFilterActive) {
            dataTableBloc.fetchPositionDetail({ uuid: atasanSelected.position_uuid })
        } else {
            setAtasanWorkUnitUuid(null)
            setLoadingPositionDetail(false)
        }

        return () => subscription.unsubscribe()
    }, [atasanSelected])

    const handleButtonSearch = () => {
        setFilter({
            'status': status
        })
        // atasan langsung (bukan row filter "Semua Data") override work_unit_uuid default
        // (peg_detail sendiri) dengan work unit dari jabatan yang dipilih (termasuk Plt/Plh).
        // exclude_self=0 supaya cuti milik peg_detail sendiri (yang diajukan di jabatan
        // definitif) tetap muncul saat dilihat dari cakupan hirarki jabatan Plt-nya.
        // strict_scope=1 supaya list khusus hirarki atasan yang dipilih aja, gak ke-OR sama
        // tugas tambahan pemohon atau paid_leave_atasan_nip pemohon dari unit lain.
        setAdditionalFilter(
            isJabatanFilterActive && atasanWorkUnitUuid
                ? { work_unit_uuid: atasanWorkUnitUuid, exclude_self: '0', strict_scope: '1' }
                : undefined
        )
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            <Link to={`/izinpegawai/cuti.html`}>
                                <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                            </Link>
                        </div>
                        <CardTitle>List Pengajuan Cuti Bawahan</CardTitle>
                        <CardSubtitle className="mb-3">
                            Kelola Pengajuan Cuti Bawahan
                        </CardSubtitle>
                        <hr />
                        <Row className="mb-1">
                            <label className="col-md-3">
                                NIP
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_nip
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Nama
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_full_name
                                }
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <label className="col-md-3">
                                Unit Kerja
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_work_unit_name
                                }
                            </Col>
                        </Row>

                        <Row className="mb-1">
                            <label className="col-md-3 col-form-label">
                                Jabatan
                            </label>
                            <Col md="9">
                                <Select
                                    options={jabatanOptions}
                                    isAvForm={false}
                                    isClearable={false}
                                    isDisabled={!hasPlt}
                                    isLoading={loadingAtasan || loadingPositionDetail}
                                    placeholder="Pilih Jabatan"
                                    value={selectedJabatanOption}
                                    onChange={opt => setAtasanSelected(opt ? opt.model : null)}
                                />
                                {
                                    loadingPositionDetail &&
                                    <small className="text-muted">Memuat data jabatan...</small>
                                }
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Label className="col-md-3 col-form-label">
                                Status Cuti
                            </Label>
                            <Col md="4">
                                <Select options={statusCuti} isAvForm={false} isClearable={true} onChange={opt => setStatus(opt ? opt.value : null)} defaultValue={-1}/>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="3"></Col>
                            <Col md="10">
                                <Button
                                    color="primary"
                                    type="button"
                                    disabled={loadingPositionDetail}
                                    onClick={() => {
                                        handleButtonSearch()
                                    }}
                                >
                                    <i className="uil-search-alt"></i> {loadingPositionDetail ? "Memuat..." : "Cari"}
                                </Button>
                            </Col>
                        </Row>

                        <hr />

                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} employee={peg_detail} filter={filter} additionalFilter={additionalFilter} />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}
// 01-04-2022
export default ListAtasanView
